export const getCurrentPeriod = ()=> {
    const [ year,month ] = new Date().toISOString().split("-");

    return  month > 8 ? +year : year - 1;
}